import React from 'react';
import styled from '@emotion/styled';

import { LabelElement } from './LabelElement';

import { hideBrowserCheckboxAndRadio } from '../styles';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const Input = styled.input(hideBrowserCheckboxAndRadio, {
  '.B & + label': {
    marginLeft: pxToRem(16),
    marginTop: pxToRem(24),

    [mqBreakpoints.tablet]: {
      marginLeft: 0,
      marginTop: 0,
    },
  },

  '& + label': {
    marginBottom: pxToRem(16),
    paddingLeft: pxToRem(36),
    position: 'relative',

    [mqBreakpoints.tablet]: {
      marginBottom: pxToRem(24),
    },
  },

  '& + label:before': {
    content: '""',
    background: 'var(--color-white)',
    border: '1px solid var(--color-grey)',
    borderRadius: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    transition: 'all 0.2s ease',
    width: pxToRem(24),
    height: pxToRem(24),
  },

  '&:checked + label:before': {
    borderColor: 'var(--color-body)',
  },

  '&:hover + label:before, &:focus + label:before': {
    borderColor: 'var(--color-body)',
    boxShadow: '0 0 0 1px var(--color-body)',
  },

  '&+ label:after': {
    content: '""',
    background: 'transparent',
    borderRadius: '100%',
    transition: 'all 0.2s ease',
    position: 'absolute',
    top: pxToRem(5),
    left: pxToRem(5),
    width: pxToRem(16),
    height: pxToRem(16),
  },

  '&:checked + label:after,': {
    background: 'var(--color-body)',
  },
});

type Props = {
  checked: boolean;
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
};

export const RadioInputWithLabel: React.FC<Props> = props => {
  const { checked, id, label, value, onChange } = props;

  return (
    <>
      <Input id={id} type={'radio'} checked={checked} value={value} onChange={e => onChange(e.target.value)} data-testid={id} />
      {label && <LabelElement htmlFor={id} label={label} />}
    </>
  );
};
